import { memo } from 'react';
import PropTypes from 'prop-types';
import AgentLoadingRipple from './AgentLoadingRipple';
import AgentToolLoadingStrip from './AgentToolLoadingStrip';

const AgentMessageLoading = memo(function AgentMessageLoading({
  mode = 'default', // 'default' | 'searching' | 'tool'
  searchType = 'characteristics_search',
  searchStartTime = null,
  toolName = '',
  toolStartTime = null
}) {
  // Async company search (TD-2334): themed words + the search kind's poll label.
  // key={searchStartTime} remounts on each new search so the word + timer restart in lockstep.
  if (mode === 'searching') {
    return (
      <AgentToolLoadingStrip
        key={searchStartTime}
        mode="searching"
        searchType={searchType}
        startTime={searchStartTime}
      />
    );
  }

  // Any other tool (TD-2341): the same one-liner with the live tool label + generic words. Key on
  // tool name + start so consecutive tools that share a start millisecond still remount (fresh
  // label/word/timer) instead of reusing the previous tool's frozen state.
  if (mode === 'tool') {
    return (
      <AgentToolLoadingStrip
        key={`${toolName}:${toolStartTime}`}
        mode="tool"
        toolName={toolName}
        startTime={toolStartTime}
      />
    );
  }

  // Default loading animation for thinking/processing.
  return (
    <div className="agent-message-loading">
      <AgentLoadingRipple />
    </div>
  );
});

AgentMessageLoading.propTypes = {
  mode: PropTypes.oneOf(['default', 'searching', 'tool']),
  searchType: PropTypes.string,
  searchStartTime: PropTypes.number,
  toolName: PropTypes.string,
  toolStartTime: PropTypes.number
};

export default AgentMessageLoading;
